'use strict';

var _ = require('lodash');
var ProfileChartLowestClassAvailableDataService = function ProfileChartLowestClassAvailableDataService() {
  function findMatchingDataCurves(squareIndicatorsType, curvesData) {
    return _.filter(curvesData, {
      squareIndicatorsType: squareIndicatorsType
    });
  }
  function defineRanges(lcaCurve, minDtd, lcaEffAvailCurve) {
    var ranges = [];
    var prevLcaValue;
    _.eachRight(lcaCurve, function (lcaDataPoint) {
      if (lcaDataPoint.value !== prevLcaValue) {
        ranges.push({
          from: lcaDataPoint.dtd,
          to: minDtd,
          lca: lcaDataPoint.value,
          effAvail: _.find(lcaEffAvailCurve, {
            dtd: lcaDataPoint.dtd
          }) ? _.find(lcaEffAvailCurve, {
            dtd: lcaDataPoint.dtd
          }).value : undefined
        });
        // update previous range if it exists
        if (ranges.length > 1 && ranges[ranges.length - 2]) {
          ranges[ranges.length - 2].to = ranges[ranges.length - 1].from + 1;
        }
        prevLcaValue = _.clone(lcaDataPoint.value);
      }
    });
    return ranges;
  }
  function getArrayChunkFromRange(matchingDataCurve, range) {
    return _.filter(matchingDataCurve.curveData, function (el) {
      return range.from >= el.dtd && el.dtd >= range.to;
    });
  }
  function updateArrayChunk(arrayChunk, curveType, range) {
    _.each(arrayChunk, function (arrayEl, index) {
      if (index === arrayChunk.length - 1) {
        arrayEl.squareIndicatorsType = curveType;
      }
      arrayEl.lca = range.lca;
      arrayEl.effAvail = range.effAvail;
    });
  }
  function addSquareIndicatorsAttributes(transformedCurvesData, curveType, lcaCurve, lcaEffAvailCurve) {
    var matchingDataCurves = findMatchingDataCurves(curveType, transformedCurvesData);
    _.each(matchingDataCurves, function (matchingDataCurve) {
      var minDtd = _.first(matchingDataCurve.curveData).dtd;
      var ranges = defineRanges(lcaCurve, minDtd, lcaEffAvailCurve);
      _.each(ranges, function (range) {
        var arrayChunk = getArrayChunkFromRange(matchingDataCurve, range);
        updateArrayChunk(arrayChunk, curveType, range);
      });
    });
  }
  function transformLcaCurves(transformedCurvesData, rawData) {
    addSquareIndicatorsAttributes(transformedCurvesData, 'curr', rawData.lowestClassAvailableCurveCurrentYear, rawData.lcaEffAvailCurveCurrentYear);
    addSquareIndicatorsAttributes(transformedCurvesData, 'curr-ly', rawData.lowestClassAvailableCurveLastYear, rawData.lcaEffAvailCurveLastYear);
  }
  function extendToDtd(curve, currentDtd) {
    var firstDataPoint = _.first(curve) || {};
    var extendDtds = _.range(currentDtd, firstDataPoint.dtd).map(function (i) {
      return {
        dtd: i,
        value: firstDataPoint.value
      };
    });
    return _.chain(curve).union(extendDtds).uniq('dtd').sortBy('dtd').value();
  }
  function extendCurvesToDtd(rawData, dtd) {
    var curves = _.pick(rawData, ['lowestClassAvailableCurveCurrentYear', 'lcaEffAvailCurveCurrentYear']);
    return _.assign(rawData, _.reduce(curves, function (result, curve, curveName) {
      return _.set(result, curveName, !_.isNil(curve) ? extendToDtd(curve, dtd) : []);
    }, {}));
  }
  function resolveLowestClassAvailableInconsistency(rawData, dtd, lca) {
    function modify(item, lca) {
      var isLcaDifferent = !_.isUndefined(lca) && item.value !== lca;
      return isLcaDifferent ? _.assign(item, {
        value: lca
      }) : item;
    }
    var curve = _.chain(rawData).get('lowestClassAvailableCurveCurrentYear', []).map(function (item) {
      return item.dtd === dtd ? modify(item, lca) : item;
    }).value();
    return _.assign(rawData, {
      lowestClassAvailableCurveCurrentYear: curve
    });
  }
  function prepareData(rawData, dtd, lca) {
    return resolveLowestClassAvailableInconsistency(extendCurvesToDtd(rawData, dtd), dtd, lca);
  }
  return {
    transformLcaCurves: transformLcaCurves,
    extendToDtd: extendToDtd,
    prepareData: prepareData
  };
};
ProfileChartLowestClassAvailableDataService.$inject = [];
module.exports = ProfileChartLowestClassAvailableDataService;